const imageModules = import.meta.glob('./*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const allImages = Object.entries(imageModules)
  .map(([path, src]) => ({ path, src: src as string }))
  .sort((a, b) => a.path.localeCompare(b.path));

const floorPlanFiles = allImages.filter(i => i.path.includes('Floorplan'));
const photoFiles = allImages.filter(i => !i.path.includes('Floorplan'));

export const mirotinImages: string[] = photoFiles.map(i => i.src);
export const mirotinFloorPlans = [
  { image: floorPlanFiles.find(f => f.path.includes('3D'))!.src, label: 'Přízemí 3D' },
  { image: floorPlanFiles.find(f => f.path.includes('2D'))!.src, label: 'Přízemí 2D' },
];
